import "katex/dist/katex.min.css";
import LectureNotes from "@/components/note/LectureNotes";
import MeetingNotes from "@/components/note/MeetingNotes";

export default function NoteRenderer({ notes, density = "compact", mode = "print", hwFont = "Caveat" }) {
  if (!notes) return null;
  const isMeeting = notes.format === "meeting";
  const hw = mode === "handwritten" ? " hw-mode" : "";
  const style = mode === "handwritten" ? { "--hw-font": `"${hwFont}"` } : undefined;
  return (
    <article
      data-testid="note-renderer"
      data-mode={mode}
      data-hw-font={mode === "handwritten" ? hwFont : undefined}
      style={style}
      className={`max-w-3xl leading-relaxed density-${density}${hw}`}
    >
      {isMeeting ? <MeetingNotes n={notes} /> : <LectureNotes n={notes} />}
    </article>
  );
}
